<template lang="pug">
  div(class="bg-yellow-lighter px-ds-md py-ds-md w-full border-b border-b-black10 rounded-t-md rounded-b-none lg:rounded-b-md lg:shadow-rebrand lg:mt-ds-sm")
    div(class="flex flex-nowrap text-base leading-normal text-gray-800 italic")
      Icon(
        class="mt-ds-xxxs flex-none col-span-2 lg:col-span-1 text-black60 fill-black60 mr-ds-md"
        :size="32"
        name="i:calendar-1")
      .flex.items-center
        div(class="remark-title col-span-10 lg:col-span-1 text-black60") We currently have availability;&nbsp;
          br(class="block sm:hidden")
          span(class="font-bold") {{ output }}
</template>

<script>
export default {
  name: "AvailabilityRemark",

  props: {
    block: {
      type: Object, // Record<string, any>
      required: true
    },
    virgin: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      output: "",
      day: 0,
      hour: 0
    }
  },

  computed: {},

  created() {
    this.getNow()
    let today = ""
    if (this.hour < 19) {
      today = "Today, "
    }

    if (this.day <= 5) {
      this.output = today + "Tomorrow and all week!"
    } else {
      this.output = today + "Tomorrow and all of next week!"
    }
  },

  methods: {
    getNow() {
      const now = new Date()
      this.day = now.getDay()
      this.hour = now.getHours()
    }
  }
}
</script>

<style lang="css" module>
.remark {
  :global {
    .remark-content {
      @apply text-center;
      .remark-title {
        @apply font-normal;
      }
    }
  }
}
</style>
